import { render } from "./HomeFooter.vue?vue&type=template&id=f630c8aa&scoped=true"
import script from "./HomeFooter.vue?vue&type=script&lang=js"
export * from "./HomeFooter.vue?vue&type=script&lang=js"

import "./HomeFooter.vue?vue&type=style&index=0&id=f630c8aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f630c8aa"]])

export default __exports__